import React from 'react';
import { ArrowRight, Clock, Star, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import homecommunityimage from '../../assets/images/home-community.webp';

const FinalCTASection: React.FC = () => {
  return (
    <section className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            {/* Left Content */}
            <div className="lg:w-1/2 p-8 sm:p-12 flex flex-col justify-center">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                Get started on your journey
              </h2>
              <p className="text-lg text-gray-600 mb-8">
                Your next big breakthrough is just 20 minutes a day away. Experience Nood's micro-learning methodology with our annual or monthly plan.
              </p>
              
              <div className="mb-8">
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-4">
                    <Clock className="text-primary" size={20} />
                  </div>
                  <span className="text-gray-700">Just 20 minutes a day</span>
                </div>
                
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-4">
                    <Star className="text-primary" size={20} />
                  </div>
                  <span className="text-gray-700">Expert-led courses</span>
                </div>
                
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-4">
                    <Users className="text-primary" size={20} />
                  </div>
                  <span className="text-gray-700">Supportive community</span>
                </div>
              </div>
              
           
            </div>

            {/* Right Content - Image */}
            <div > <a href='/community'>
              <img 
                src={homecommunityimage} 
                alt="Join our community" 
                className="h-full w-full object-cover"
              />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
